import React from 'react';
import { FiCheck } from 'react-icons/fi';
import { colors } from '../util/notes.mjs';

const ColorPalette = function({color, onChange, label}) {
  return <div className='palette h' role='group' aria-label={label}>
      {colors.map(item => <button
        key={item.id}
        className='colorButton'
        style={{
          background: `var(--note-${item.id}, ${item.value})`
        }}
        title={item.name.toLowerCase()}
        aria-label={item.name.toLowerCase()}
        aria-pressed={color === item.id}
        onClick={() => onChange(item.id)}
      >
          {color === item.id && <FiCheck size={12} aria-hidden='true' />}
        </button>)}
    </div>;
};

export default ColorPalette;
